import React from 'react';
import styled from 'styled-components';
import { BasicButton, BasicButtonProps } from './BasicButton';

const StyledButton = styled(BasicButton)`
  padding: 6px 12px;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  color: white;
  font-weight: 500;
  background-color: ${(props) => props.theme.colors.primary};
  box-shadow: 3px 3px 3px darkgray;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryHover};
  }

  &:active {
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const PrimaryButton = (props: BasicButtonProps) => {
  return (
    <StyledButton {...props}/>
  );
};

export {
  PrimaryButton,
};